<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="1.1" stepTitle="价格与套餐"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">价格库存</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="抢购日期范围" prop="preSaleDate">
              <a-range-picker name="buildTime" :disabledDate="disabledDate" :disabled="proSource!=0"
                              v-model="ruleForm.preSaleDate"
                              @change="onDateChange" show-time
                              format="YYYY-MM-DD HH:mm"/>
            </a-form-model-item>
            <a-form-model-item label="同行价" prop="mfAuditPrice">
              <a-input v-model="ruleForm.mfAuditPrice" :disabled="proSource!=0" placeholder="请输入"/>
            </a-form-model-item>
            <a-form-model-item label="建议销售价" prop="advicePrice">
              <a-input v-model="ruleForm.advicePrice" :disabled="proSource!=0" placeholder="请输入"/>
            </a-form-model-item>
            <a-form-model-item v-if="proSource!=0" label="实际销售价" prop="actualSalePrice">
              <a-input v-model="ruleForm.actualSalePrice" :disabled="ruleForm.priceDistAdjust==1" placeholder="请输入"/>
            </a-form-model-item>
            <a-form-model-item label="佣金" prop="commissionPrice">
              <a-input v-model="ruleForm.commissionPrice" :disabled="merchantLoginType==0" placeholder="请输入"/>
            </a-form-model-item>
            <a-form-model-item label="市场价" prop="marketPrice">
              <a-input v-model="ruleForm.marketPrice" :disabled="proSource!=0" placeholder="请输入"/>
            </a-form-model-item>
            <a-form-model-item v-if="proSource==0" label="采购价" prop="purchasePrice">
              <a-input v-model="ruleForm.purchasePrice" placeholder="请输入"/>
            </a-form-model-item>
            <a-form-model-item label="库存" prop="stock">
              <a-input v-model="ruleForm.stock" :disabled="proSource!=0" placeholder="请输入"/>
            </a-form-model-item>
            <a-form-model-item label="预警" prop="warning">
              <a-input v-model="ruleForm.warning" :disabled="proSource!=0" placeholder="请输入"/>
            </a-form-model-item>
            <a-form-model-item label="分销价格调整权限">
              <a-select v-model="ruleForm.priceDistAdjust" :disabled="proSource!=0" placeholder="请选择"
                        style="max-width:700px;">
                <a-select-option :value="1">不可调整</a-select-option>
                <a-select-option :value="2">不可低于建议销售价</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="是否需要二次确认">
              <a-select v-model="ruleForm.isConfirm" :disabled="proSource!=0" placeholder="请选择"
                        style="max-width:700px;">
                <a-select-option :value="0">不需要</a-select-option>
                <a-select-option :value="1">需要</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="merchantLoginType==0" @click="onSubmit" :loading="submitLoading">
                提交
              </a-button>
              <!-- <a-button  @click="backEvent" style="margin-left: 10px">保存草稿</a-button> -->
            </a-form-model-item>
          </a-form-model>
        </a-card>
        <!-- 产品发布按钮 -->
        <PublishPro></PublishPro>
      </div>
    </div>
    <CommissionComponent
      :proCatalog="catalogId"
      :optionId="optionIdSet"
      :proId="proId"
    ></CommissionComponent>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import PublishPro from '../components/PublishPro'
import moment from 'moment'
import CommissionComponent from '@/views/product/components/CommissionComponent'

export default {
  name: 'PresellPriceSet',
  components: {
    ProductHeader,
    PublishHelper,
    PublishPro,
    CommissionComponent
  },
  mixins: [ruleFormMixins],
  data() {
    var checkAdvicePrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) < Number(this.ruleForm.mfAuditPrice)) {
          callback(new Error('建议销售价必须要大于或等于同行价'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkCommissionPrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Math.round(Math.round(Number(this.ruleForm.advicePrice) * 100) - Math.round(Number(this.ruleForm.mfAuditPrice) * 100) - Math.round(Number(value) * 100)) / 100 < 0) {
          callback(new Error('必须小于建议销售价减同行价'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkWarning = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(this.ruleForm.stock) < Number(value)) {
          callback(new Error('预警值不能大于库存'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      moment,
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      optionIdSet: this.$route.query.optionIdSet,
      merchantLoginType: this.$store.getters.userInfo.merchantLoginType,
      merchantId: this.$store.getters.userInfo.merchantId,
      optionId: 0,
      ruleForm: {
        preSaleDate: undefined,//保存时删除
        adviceChildPrice: 0, //建议销售儿童价
        advicePrice: '', //建议销售价;建议销售成人价
        childMarketPrice: 0, //市场儿童价
        commissionPrice: '', //佣金
        commissionChildPrice: '', //儿童价佣金
        dates: '', //日期
        isConfirm: 1, // 是否需要再次确认 0 不需要 1 需要 ,
        marketPrice: '', //市场价 ;市场成人价 ,
        merchantId: 0, //商户Id
        mfAuditChildren: 0, //儿童同行价
        priceDistAdjust: 1, // 分销价格调整权限 0 自有调整 1 不可调整 2 不可低于建议销售价 ,
        mfAuditPrice: '', //同行价;成人同行价 ,
        proId: this.$route.query.proId,
        purchaseChildprice: 0, //采购儿童价
        purchasePrice: '', //采购价;采购成人价
        stock: '', //库存
        warning: '', //警告
        priceDifferenceRoom: 0 //单房差
      },
      bedTypeList: [],
      hotelBindBeds: [],
      submitLoading: false,
      submitFormData: '',
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      rules: {
        preSaleDate: [
          { required: true, message: '请选择抢购日期范围', trigger: 'change' }
        ],
        mfAuditPrice: [
          { required: true, message: '请输入同行价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额(可带两位小数)',
            trigger: 'blur'
          }
        ],
        advicePrice: [
          { required: true, message: '请输入建议销售价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额(可带两位小数)',
            trigger: 'blur'
          },
          { validator: checkAdvicePrice, trigger: 'blur' }
        ],
        marketPrice: [
          { required: true, message: '请输入市场价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额(可带两位小数)',
            trigger: 'blur'
          }
        ],
        purchasePrice: [
          { required: true, message: '请输入采购价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额(可带两位小数)',
            trigger: 'blur'
          }
        ],
        commissionPrice: [
          {
            pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/,
            message: '请输入正确的金额(可带两位小数)',
            trigger: 'blur'
          },
          { validator: checkCommissionPrice, trigger: 'blur' }
        ],
        stock: [
          { required: true, message: '请输入库存', trigger: 'blur' },
          { pattern: /^[1-9]\d{0,5}$/, message: '请输入正确的库存', trigger: 'blur' }
        ],
        warning: [
          { pattern: /^[0-9]\d{0,3}$/, message: '请输入正确的预警', trigger: 'blur' },
          { validator: checkWarning, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getProPriceInfo()
  },
  methods: {
    //领取日期
    onDateChange(dates, dateStrArr) {
      this.getLogUtils().logWithTag('onDateChange', dates)
      this.getLogUtils().logWithTag('onDateChange', dateStrArr)
      this.ruleForm.preSaleDate = dates
      this.ruleForm.startTime = dateStrArr[0]
      this.ruleForm.endTime = dateStrArr[1]
      this.ruleForm = {
        ...this.ruleForm
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitFormData.isPreSale = 1
      this.submitFormData.dates = '3019-01-01'
      delete this.submitFormData.preSaleDate
      this.getLogUtils().logWithTag('submitData', this.submitFormData)
      let path = ''
      //proSource 0 是自有产品 1是非自有产品
      if (this.proSource == 0) {
        path = 'priceCalendar/savePriceCalendarSelfOwned'
      } else {
        path = 'priceCalendar/savePriceCalendarNonMySelf'
      }
      this.getHttpServices().getProService().post(path, this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('价格设置成功')

      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取信息
    getProPriceInfo() {
      let path
      if (this.proSource == 0) {
        path = 'priceCalendar/getPreSalePriceByProId/' + this.proId
      } else {
        //判断非自有产品
        path = 'priceCalendar/getPreSalePriceNotSelft/' + this.proId + '/' + this.merchantId
      }
      this.getHttpServices().getProService().get(path).then(res => {
        this.getLogUtils().logWithTag('getProPriceInfo', res)
        this.ruleForm = res
        this.ruleForm.priceDistAdjust = res.priceDistAdjust ? res.priceDistAdjust : 1
        this.ruleForm.isConfirm = res.isConfirm == 1 ? res.isConfirm : 0
        if (res.startTime && res.endTime) {
          this.ruleForm.preSaleDate = this.getDateHelper().getDateMoments(res.startTime, res.endTime)
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }

    input {
      max-width: 700px;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.card-txt {
  font-size: 12px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>